module.exports = __webpack_public_path__ + "static/media/179.298a5e29.jpg";